import React, { Component } from 'react';
import Cities from './pages/Cities/';
import NewCity from './pages/Cities/NewCity';
import Bookings from './pages/Bookings/';
import Customers from './pages/Customers/';
import Ratings from './pages/Ratings/'; //[RATINGS] - check if updates needed
import Dashboard from './pages/Dashboard/';
import Trips from './pages/Trips/';
import Admins from './pages/Admins/';
import NewAdmin from './pages/Admins/NewAdmin';

import './css/main.scss';

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import Login from './pages/Login/Login';
import store from './store';
import { connectLiveTickets } from './store/tickets/actions';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import { userPermissions } from './config';
import EditProfile from './pages/Profile/EditProfile';
import EditAdmin from './pages/Admins/EditAdmin';
import { TranslationComponent } from './pages/Translation';
import { ExportCustomers } from './pages/Customers/ExportCustomers';

const checkActive = (match, location) => {
  //some additional logic to verify you are in the home URI
  if(!location) return false;
  const {pathname} = location;
  // console.log(pathname);
  return pathname === "/";
}

const PrivateRoute = ({ component: Component, ...rest }) => {
  const user = store.getState().user;

  return <Route {...rest} render={props => {
    if(user.authed) {
      return <Component {...props} />
    } else {
      return <Redirect to={{
        pathname: '/login',
        state: { from: props.location, referer: rest.computedMatch.path }
      }} />
    }}} />
}

const RequiresPermission = ({ component: Component, permission, ...rest }) => {
  const permissions = store.getState().user.permissions;

  if (permissions.includes(permission)) {
    return <PrivateRoute component={Component} {...rest} />
  } else {
    return <Redirect to={{
      pathname: '/login',
      state: {
        referer: rest.path,
      }
    }} />
  }
}


class App extends Component {
  componentDidMount() {
    const user = store.getState().user;
    if(user.authed) {
      // connect to socket
      store.dispatch(connectLiveTickets());
    }
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/reset/:token" component={ResetPassword} />
          {/* <PrivateRoute exact path="/" isActive={checkActive} component={Dashboard} /> */}
          <PrivateRoute exact path="/profile" component={EditProfile} />
          <RequiresPermission path="/cities" permission={userPermissions.viewSettings} component={Cities} />
          <RequiresPermission path="/new-city" permission={userPermissions.viewSettings} component={NewCity} />
          <RequiresPermission path="/bookings" permission={userPermissions.viewBookings} component={Bookings} />
          <Route path="/ratings" component={Ratings}/>
          <RequiresPermission path="/customers" permission={userPermissions.viewCustomers} component={Customers} />
          <RequiresPermission path="/customer-exports" permission={userPermissions.viewCustomers} component={ExportCustomers} />
          <RequiresPermission path="/trips" permission={userPermissions.viewSettings} component={Trips} />
          <RequiresPermission path="/admins" permission={userPermissions.viewSettings} component={Admins} />
          <RequiresPermission path="/edit-admin/:adminID" permission={userPermissions.viewSettings} component={EditAdmin} />
          <RequiresPermission path="/new-admin" permission={userPermissions.viewSettings} component={NewAdmin} />
          <RequiresPermission path="/translation" permission={userPermissions.viewSettings} component={TranslationComponent} />
          <Redirect to={{ pathname: '/bookings' }} />
        </Switch>
      </Router>
      );
    }
  }
  
export default App;

